import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { OfficeForm } from 'src/routes/Settings/Offices/components/OfficeForm';

export const CreateOffice: React.FC = () => {
  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Offices', href: '/settings/offices' },
            { text: 'Create Office' },
          ],
        }}
        title="Create Office"
        helpText="Create a new office with divisions, modules, workflows, and daily settings."
      />
      <OfficeForm />
    </>
  );
};
